import React from "react"

export default class Footer extends React.Component {
  render() {
    return (
      <div className="footer"></div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/core/components/footer.jsx